import { ReactNode } from "react";
import {
  Popover,
  PopoverAnchor,
  PopoverContent,
} from "@/lib/components/Popover";
import { useOneTimeHint } from "@/lib/hooks/use-one-time-hint";
import { Button } from "@/lib/components/Button/Button";

type Props = {
  isDialogOpen: boolean;
  children: (args: { dismiss: () => void }) => ReactNode;
};

export default function CreativeModeIntroHint({
  isDialogOpen,
  children,
}: Props) {
  const { isOpen, dismiss } = useOneTimeHint("creativeModeIntroSeen");

  if (!isDialogOpen) {
    return null;
  }

  return (
    <Popover open={isOpen}>
      <PopoverAnchor asChild>{children({ dismiss })}</PopoverAnchor>
      <PopoverContent
        variant="black"
        side="right"
        align="center"
        sideOffset={4}
        className="w-80"
        collisionPadding={32}
        onOpenAutoFocus={(event) => event.preventDefault()}
        onPointerDownOutside={(event) => event.preventDefault()}
        onInteractOutside={(event) => event.preventDefault()}
        onEscapeKeyDown={(event) => event.preventDefault()}
      >
        <div className="flex flex-col gap-3">
          <div className="flex aspect-video w-full items-center justify-center overflow-hidden rounded-md">
            <video
              src="/CREATIVE_MODE_HINT.mp4"
              autoPlay
              muted
              loop
              playsInline
            />
          </div>
          <div className="mb-2 flex flex-col gap-2">
            <h3 className="text-base font-semibold text-white/95">
              Speed ramps, actors, and more!
            </h3>
            <p className="text-sm text-white/80">
              Try Creative Mode to generate fully custom images and animations.
            </p>
          </div>
          <Button
            variant="outline"
            size="sm"
            className="w-full"
            onClick={dismiss}
          >
            Got it
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
